const actionErrorMappings = {
  auto_start_failed_reason: {
    'VEHICLE_CONFLICT': 'Silakan pilih kendaraan yang tersedia'
  },
  vehicle_id: {
    'vehicle box type different': 'Ubah kendaraan agar sesuai jenis box pengiriman',
  },
  driver_user_id: {
    'driver user group invalid': 'Silakan pilih pengemudi yang tersedia'
  },
  driver_user_2_id: {
    'driver user group invalid': 'Silakan pilih pengemudi tambahan yang tersedia'
  },
  box_type_id: {
    'invalid value': 'Jenis box tidak ditemukan.',
  },
}

export default actionErrorMappings
